import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';

export const ConnectedUsers = styled.div`
    align-items: center;
    display: flex;
    margin: 7px;
`;

export const MoreUsers = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.primary300};
    font-size: 13px;
    font-weight: 600;
    height: 25px;
    margin-left: 4px;
    padding: 4px 8px;
    transition: background-color 200ms linear;
    &:hover {
        background-color:${({ theme }) => theme.colors.pastelPrimary300};
    }
`;

export const UsersWrapper = styled.div`
    display: flex;
    flex-direction: row-reverse;
`;

export const AvatarBackground = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 100%;
    height: 32px;
    margin-left: -4px;
    position: relative;
    width: 32px;
`;

export const AvatarWrapper = styled.div`
    align-items: center;
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 100%;
    border: 2px solid ${({ borderColor }) => borderColor};
    bottom: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
`;

export const Initials = styled.span`
    color: #26455E;
    font-size: 11px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
`;

export const BananatagLogo = styled.img`
    width: 28px;
    height: 28px;
`;

export const Tooltip = styled(ReactTooltip)`
    &.type-dark.place-bottom {
        font-weight: 600;
        padding: 4px 8px;
        margin-top: 8px;
        background-color: #535454;
        border-radius: 4px;
    }
    &.__react_component_tooltip.type-dark.place-bottom:after {
        border: none;
    }
`;

export const TooltipText = styled.span`
    font-weight: 600;
    position: relative;
    bottom: 2px;
`;
